import { useRef } from 'react';
// import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTheme } from '@mui/material/styles';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { ImageLoader } from '~/content/components/ImageLoader';
import { useTranslation } from 'react-i18next';

import sentry from '~/content/images/references/technologies/sentry.webp';
import tiptap from '~/content/images/references/technologies/tiptap2.webp';
import synk from '~/content/images/references/technologies/synk.webp';
// import drizzle from '~/content/images/references/technologies/drizzle2.webp';
import remix from '~/content/images/references/technologies/remix2.webp';
import tailwind from '~/content/images/references/technologies/tailwind2.webp';
import itdlz from '~/content/images/references/technologies/itdlz.webp';

const Technologies = (): JSX.Element => {
	const mock = [
		{
			logo: sentry,
			darkModeFilter: true,
			alt: 'Sentry Bug Beseitigung',
			scale: '1.0',
			ref: useRef(null),
		},
		{
			logo: tiptap,
			darkModeFilter: true,
			alt: 'TipTap Texteditior',
			scale: '1',
			ref: useRef(null),
		},
		{
			logo: synk,
			darkModeFilter: false,
			alt: 'Synk IT-Sicherheit Softwareentwicklung',
			scale: '1.0',
			ref: useRef(null),
		},
		{
			logo: tailwind,
			darkModeFilter: true,
			alt: 'Styling Website und Apps individuell mit Tailwind',
			scale: '1.15',
			ref: useRef(null),
		},
		{
			logo: remix,
			darkModeFilter: true,
			alt: 'WebApp Entwicklung Remix',
			scale: '0.9',
			ref: useRef(null),
		},

		{
			logo: itdlz,
			darkModeFilter: true,
			alt: 'IT-Dienstleistungszentrum des Freistaats Bayern',
			scale: '1.2',
			ref: useRef(null),
		},
	];

	let { t } = useTranslation(['project_stk-portal']);
	const theme = useTheme();

	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	return (
		<Grid container spacing={4}>
			<Grid item container xs={12} md={6} alignItems={'center'}>
				<Box paddingBottom={1}>
					<Typography mb={2} component='h3' variant='h5' gutterBottom sx={{ fontWeight: 700 }}>
						{t('technologies_headline')}
					</Typography>
					<Typography variant={isMd ? 'body1' : 'body1'} component='p' color='text.secondary'>
						{t('technologies_text')}
					</Typography>
				</Box>
			</Grid>
			<Grid item container spacing={2} xs={12} md={6}>
				{mock.map((item, i) => (
					<Grid item xs={4} key={i}>
						<Box
							display={'block'}
							width={1}
							height={1}
							// sx={{
							// 	transition: 'all .2s ease-in-out',
							// 	'&:hover': {
							// 		transform: `translateY(-${theme.spacing(1 / 2)})`,
							// 	},
							// }}
						>
							<Card
								sx={{
									borderRadius: '0',
									boxShadow: 0,
									backgroundColor:
										theme.palette.mode === 'dark'
											? theme.palette.primary.contrastText
											: theme.palette.background.level2,
									// backgroundColor:
									// 	theme.palette.mode === 'dark' ? '#f6f6f6' : theme.palette.background.level2,
									// filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
								}}
							>
								{isMd ? (
									<CardContent
										sx={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											padding: 3,
										}}
									>
										<ImageLoader
											delay={true}
											intersectViewportCheck={true}
											style={{
												width: 'auto', //! do not remove
												height: 'auto', //! do not remove
												filter:
													theme.palette.mode === 'dark' && item.darkModeFilter
														? 'brightness(0) invert(1)'
														: 'none',
											}}
											childRef={item.ref}
										>
											<Box
												ref={item.ref}
												component={'img'}
												height={50}
												width={115}
												sx={{
													objectFit: 'contain',
													scale: item.scale ? item.scale : '100%',
												}}
												src={item.logo}
												alt={item.alt}
											/>
										</ImageLoader>
									</CardContent>
								) : (
									<CardContent
										sx={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											padding: isSm ? 4 : 1,
											paddingBottom: isSm ? '' : '8px !important',
											// paddingBottom: '8px !important', //! needs to be the same as padding in "sx"
										}}
									>
										<ImageLoader
											delay={true}
											intersectViewportCheck={true}
											style={{
												width: 'auto', //! do not remove
												height: 'auto', //! do not remove
												filter:
													theme.palette.mode === 'dark' && item.darkModeFilter
														? 'brightness(0) invert(1)'
														: 'none',
											}}
											childRef={item.ref}
										>
											<Box
												ref={item.ref}
												component={'img'}
												height={50}
												width={isSm ? 130 : 90}
												sx={{
													objectFit: 'contain',
													scale: item.scale ? item.scale : 1,
												}}
												src={item.logo}
												alt={item.alt}
											/>
										</ImageLoader>
									</CardContent>
								)}
							</Card>
						</Box>
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};

export default Technologies;
